import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import AgeGate from "@/components/AgeGate";

export default function SiteLayout({ children }) {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#F5F5F0] flex flex-col">
      <AgeGate />
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
